export default __webpack_public_path__ + "static/media/prototypePart1.550612d6.png";